import { Box, Container, Flex, Text, Image, Divider, SimpleGrid, Input, InputGroup, FormControl, FormLabel, Textarea, Select, InputLeftElement, ButtonGroup, Button, Center, Heading, IconButton, FormErrorMessage, Checkbox, useDisclosure } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import LoadingScreen from "components/loading-screen";
import AuthService from "services/auth/auth-service";
import Layout from "scenes/layouts";
import { FiFacebook, FiGlobe, FiInstagram, FiTwitter } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { Field, Formik, useFormik } from "formik";
import LogosNotification from "utils/notification-utils";
import { EditIcon } from "@chakra-ui/icons";
import { relative } from "path";
import { BsPencil } from "react-icons/bs";
import AppConsts from "libs/appconst";
import VoucherService from "../../services/vouchers/voucher-service";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import ProgramService from "../../services/programs/program-service";
import ConfirmDialog from "../../components/confirm-dialog";
import BannerService from "../../services/banners/banner-service";
import AuthorService from "../../services/authors/author-service";
import ReactQuill from "react-quill";

const formInitialValue = {
    name: '',
    shortBioData: '',
    about: ''
};

const modules = {
    toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'align': [] }],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
        ['link', 'image', 'video'],
        ['clean']
    ],
    clipboard: {
        // toggle to add extra line breaks when pasting HTML:
        matchVisual: false
    },
    imageResize: {
        parchment: ReactQuill.Quill.import('parchment'),
        modules: ['Resize', 'DisplaySize']
    },
    //blotFormatter: { }
};

const formats = [
    'header',
    'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent',
    'link', 'image', 'video', 'align', 'color', 'background'
];

const EditAuthorScene = (): ReactElement => {
    const navigate = useNavigate();
    const { authorId } = useParams();
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isSaving, setSaving] = useState<boolean>(false);
    const [author, setAuthor] = useState<any>(null);
    const [formValue, setFormValue] = useState<any>(formInitialValue);
    const [about, setAbout] = useState<string>('');

    useEffect(() => {
        setLoading(true);
        AuthorService.Get(authorId).then((res: any) => {
            setAuthor(res.result);
            var status = { status: res.result.status == 0 ? true : false };
            setAbout(res.result.about);
            setFormValue({ ...res.result, ...status });
        }).finally(() => {
            setLoading(false);
        });
    }, []);

    const handleFormSubmit = (values: any) => {
        setSaving(true);
        AuthorService.Update(
            authorId,
            values.name,
            values.shortBioData,
            about,
            values.status ? 0 : 1
        ).then((res: any) => {
            LogosNotification.Success("Author berhasil diperbaharui.");
            navigate(`/authors/${authorId}`);
        }).finally(() => {
            setSaving(false);
        });
    };

    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <Container maxWidth={"8xl"} pt={10}>
                <Box>
                    <Flex>
                        <Text fontSize={{ base: '2xl', md: '3xl' }} fontWeight={"bold"}>Edit Author {author.name}</Text>
                    </Flex>
                    <Formik initialValues={formValue} onSubmit={handleFormSubmit}>
                        {
                            ({ handleSubmit, errors, touched, values, setFieldValue }) => (
                                <form onSubmit={handleSubmit} noValidate={true}>
                                    <Box rounded={'lg'} fontSize={'sm'} border={'1px solid'} borderColor={'blackAlpha.400'}>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.name && touched.name)}>
                                                    <FormLabel htmlFor='name'>Nama Author</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='name'
                                                        placeholder='Nama Author'
                                                        name={'name'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Nama Author wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.name}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} pt={4}>
                                            <SimpleGrid columns={{ base: 1, md: 2 }} gap={12}>
                                                <FormControl isRequired isInvalid={!!(errors.shortBioData && touched.shortBioData)}>
                                                    <FormLabel htmlFor='shortBioData'>Profesi</FormLabel>
                                                    <Field
                                                        as={Input}
                                                        id='shortBioData'
                                                        noOfLines={3}
                                                        placeholder='Profesi'
                                                        name={'shortBioData'}
                                                        validate={(value: any) => {
                                                            let error;
                                                            if (value.length <= 0) {
                                                                error = "Profesi wajib diisi."
                                                            }
                                                            return error;
                                                        }}
                                                    />
                                                    <FormErrorMessage>{errors.shortBioData}</FormErrorMessage>
                                                </FormControl>
                                            </SimpleGrid>
                                        </Box>

                                        <Box px={8} py={4}>
                                            <FormControl>
                                                <FormLabel htmlFor='price'>Tentang Author</FormLabel>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={about}
                                                    onChange={setAbout}
                                                    placeholder="Tentang Author"
                                                    modules={modules}
                                                    formats={formats}
                                                />
                                            </FormControl>
                                        </Box>

                                        <Box px={8} py={4}>
                                            <FormControl isRequired isInvalid={!!(errors.status && touched.status)}>
                                                <FormLabel htmlFor='status'>Aktif?</FormLabel>
                                                <Field
                                                    type="checkbox"
                                                    id='status'
                                                    name={'status'}
                                                    checked={values.status}
                                                    style={{ width: '22px', height: '22px' }}
                                                >
                                                </Field>
                                                <FormErrorMessage>{errors.status}</FormErrorMessage>
                                            </FormControl>
                                        </Box>
                                        <Divider mt={4} />

                                        <Box px={8} py={8}>
                                            <ButtonGroup gap={2}>
                                                <Button type={'submit'} isLoading={isSaving}>Simpan</Button>
                                                <Button variant={'outline'} onClick={() => { navigate(`/authors/${authorId}`) }}>Kembali</Button>
                                            </ButtonGroup>
                                        </Box>
                                    </Box>
                                </form>
                            )
                        }
                    </Formik>
                </Box>
            </Container>
        </Layout >
    );
};

export default EditAuthorScene;